import type { ServerOfferStatus } from '@yoop/server-model/token-info';
import { containsUnsecuredOffer } from '@yoop/util-offer/helper';

/**
 * Checks if a group of marketplaces contains at least one marketplace with at least one unsecured offer
 * @param marketplaces
 * @param notLost
 */
export const containsUnsecuredOfferGroup: (
  marketplaces: {
    offerGroupInformation?: { activeOffer?: { offerStatus?: ServerOfferStatus } }[];
  }[],
  notLost: boolean,
) => boolean = (
  marketplaces: {
    offerGroupInformation?: { activeOffer?: { offerStatus?: ServerOfferStatus } }[];
  }[],
  notLost: boolean,
) =>
  marketplaces.some(
    (marketplace) =>
      marketplace.offerGroupInformation &&
      containsUnsecuredOffer(marketplace.offerGroupInformation, notLost),
  );
